import React, { memo } from "react"
import PropTypes from "prop-types"
import PageNavigation from "./page-navigation"

const ProcessNav = ({ buttonClick, navState, lang = "de" }) => {
  const navNames = require("../data/process.json").navigation

  return (
    <PageNavigation navClasses="process-nav">
      <button
        onClick={() => buttonClick("process")}
        {...(navState === "process"
          ? { className: "font-bold" }
          : Object.create(null))}
      >
        <label htmlFor={`process-slide-${lang}-1`}>{navNames[lang][0]}</label>
      </button>
      <button
        onClick={() => buttonClick("clients")}
        {...(navState !== "process"
          ? { className: "font-bold" }
          : Object.create(null))}
      >
        {navNames[lang][1]}
      </button>
    </PageNavigation>
  )
}

ProcessNav.propTypes = {
  buttonClick: PropTypes.func,
  lang: PropTypes.string,
  navState: PropTypes.string,
}

export default ProcessNav
